import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OperatorAvailability, OperatorEntity } from 'app/interfaces';
import { DigitalCareerDaysService } from 'app/services/digital-career-days.service';
import * as moment from 'moment';
import _ from 'lodash';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-update-availability',
  templateUrl: './update-availability.component.html',
  styleUrls: ['./update-availability.component.scss']
})
export class UpdateAvailabilityComponent implements OnInit {
  @Input() fullWidth = true;
  @Output() availabilityChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  public operator: OperatorEntity = null;
  public careerDayId: number = null;
  public isLoading = false;
  public originalAvailabilityBody: OperatorAvailability = {
    availability: []
  };

  public toggle = false;
  public errorMessage: string = null;

  public hoursRange: any[] = [
    {key: 0, value: '00'},
    {key: 1, value: '01'},
    {key: 2, value: '02'},
    {key: 3, value: '03'},
    {key: 4, value: '04'},
    {key: 5, value: '05'},
    {key: 6, value: '06'},
    {key: 7, value: '07'},
    {key: 8, value: '08'},
    {key: 9, value: '09'},
    {key: 10, value: '10'},
    {key: 11, value: '11'},
    {key: 12, value: '12'},
    {key: 13, value: '13'},
    {key: 14, value: '14'},
    {key: 15, value: '15'},
    {key: 16, value: '16'},
    {key: 17, value: '17'},
    {key: 18, value: '18'},
    {key: 19, value: '19'},
    {key: 20, value: '20'},
    {key: 21, value: '21'},
    {key: 22, value: '22'},
    {key: 23, value: '23'}
  ];

  public minutesRange: any[] = [
    {key: 0, value: '00'},
    {key: 15, value: '15'},
    {key: 30, value: '30'},
    {key: 45, value: '45'},
  ];

  public daysRange: any[] = [];

  public availabilityBody: OperatorAvailability = {
    availability: []
  };

  // public availability

  public selectedDay: string = null;
  public selectedStartHour: number = 9;
  public selectedStartMinute: number = 0;
  public selectedEndHour: number = 18;
  public selectedEndMinute: number = 0;

  constructor(
    private dcds: DigitalCareerDaysService,
    private route: ActivatedRoute,
    private toasterService: ToasterService
  ) {
      this.careerDayId = this.route.snapshot.params.careerDayId || this.route.snapshot.parent.params.careerDayId || null;
  }

  addAvailability() {
    console.log(this.selectedDay, this.selectedStartHour, this.selectedStartMinute, this.selectedEndHour, this.selectedEndMinute);
    let start: any;
    let end: any;
    start = moment(this.selectedDay).set('hours', this.selectedStartHour).set('minutes', this.selectedStartMinute);
    end = moment(this.selectedDay).set('hours', this.selectedEndHour).set('minutes', this.selectedEndMinute);

    // FIX-ME check dates (start > end && end - start > 30 min)
    // if (start > end && moment(end).diff(start, 'minutes') >= 30) {
      const clone = Object.assign({}, this.availabilityBody);
      clone.availability.push({
        allow_period: {
          start: new Date(start).toISOString(),
          end: new Date(end).toISOString()
        }
      });

      this.availabilityBody.availability = clone.availability;
      this.selectedDay = null;
      // this.errorMessage = null;
    // } else {
    //   if (end <= start) {
    //     // this.toasterService.pop('error', 'Error', 'Start date must be grater than End date');
    //     this.errorMessage = 'Start date must be grater than End date';
    //   } else if (moment(end).diff(start, 'minutes') < 30) {
    //     // this.toasterService.pop('error', 'Error', 'Slot must be equal or grater than 30 minutes');
    //     this.errorMessage = 'Slot must be equal or grater than 30 minutes';
    //   }
    // }
  }

  get checkDates(): boolean {
    let start: any;
    let end: any;
    start = moment(this.selectedDay).set('hours', this.selectedStartHour).set('minutes', this.selectedStartMinute);
    end = moment(this.selectedDay).set('hours', this.selectedEndHour).set('minutes', this.selectedEndMinute);

    if (end <= start) {
      // this.toasterService.pop('error', 'Error', 'Start date must be grater than End date');
      this.errorMessage = 'Start date must be grater than End date';
      return true;
    } else if (moment(end).diff(start, 'minutes') < 30) {
      // this.toasterService.pop('error', 'Error', 'Slot must be equal or grater than 30 minutes');
      this.errorMessage = 'Slot must be equal or grater than 30 minutes';
      return true;
    } else {
      this.errorMessage = null;
      return false;
    }
  }

  removeAvailability(elem: any) {
    console.log(elem);
    this.availabilityBody.availability = this.availabilityBody.availability.filter(a => a !== elem);
  }

  saveAvailability() {
    this.isLoading = true;
    this.dcds.updateOperatorAvailability(this.careerDayId, this.availabilityBody).subscribe(result => {
      console.log(result);
      this.toasterService.pop('success', 'Success', 'Availability updated successfully');
      this.isLoading = false;
      this.availabilityChanged.emit(true);
      this.ngOnInit()
    }, error => {
      this.toasterService.pop('error', 'Error', 'Something went wrong, please try again later.');
      this.isLoading = false;
      this.availabilityChanged.emit(true);
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.toggle = false;
    this.availabilityBody.availability = [];
    this.daysRange = [];
    this.dcds.getOperator(this.careerDayId).subscribe((result) => {
      this.operator = result;
      //
      if (result.availability) {
        // this.originalAvailabilityBody.availability = result.availability;
        // this.availabilityBody.availability = result.availability;
        this.originalAvailabilityBody = {
          availability: [...result.availability]
        }

        this.availabilityBody = {
          availability: [...result.availability]
        }
      }

      this.isLoading = false;
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    });

    this.dcds.startDate = this.dcds.startDate;
    this.dcds.endDate = this.dcds.endDate;

    let  a = new Date(this.dcds.startDate);
    const b = new Date(this.dcds.endDate);
    while (a <= b) {
      this.daysRange.push({
        key: a, value: moment(a).format('D MMM')
      });
      a = moment(a).add(1, 'day').toDate();
    }
  }

  get nothingChanged(): boolean {
    // return
    // const sameLength: boolean = this.availabilityBody.availability.length === this.originalAvailabilityBody.availability.length;
    return _.isEqual(this.availabilityBody, this.originalAvailabilityBody);
  }

}
